import React from 'react';
import NinjaTable from 'components/tables/NinjaTable';
import { useJourneyReport } from 'modules/ReportModule/context/useJourneyReport';
import Icon from '@mdi/react';
import Ninja from '@ninja';
import { mdiCalendar } from '@mdi/js';
import { Flex, Typography } from 'antd';
import { DateFormatter } from 'components/charts/formatters';
import getFormattedNumber from 'store/redux/utils/getFormattedNumber';

const { Text } = Typography;

const TrafficReportingSources = () => {
  const { filter } = useJourneyReport();

  const MetricCell = ({ value, icon, color = Ninja.colors.gray }) => (
    <Flex align='center' gap={6}>
      {icon && <Icon size={0.7} path={icon} color={color} />}
      <Text strong className='text-sm'>
        {getFormattedNumber(value)}
      </Text>
    </Flex>
  );

  const MetricHeader = ({ title, icon }) => (
    <Flex align='center' gap={6}>
      {icon && <img width={20} height={20} src={icon} />}
      <span>{title}</span>
    </Flex>
  );

  const columns = [
    {
      key: 'organic_sessions',
      name: <MetricHeader title='Custom URLs' icon='/icons/networks/organic.svg' />,
      sortable: true,
      renderCell: ({ row }) => <MetricCell value={row?.organic_sessions} />,
    },
    {
      key: 'search_sessions',
      name: <MetricHeader title='Search' icon='/icons/networks/search.svg' />,
      sortable: true,
      renderCell: ({ row }) => <MetricCell value={row?.search_sessions} />,
    },
    {
      key: 'google_ads_sessions',
      name: <MetricHeader title='Google Ads' icon='/icons/networks/google.svg' />,
      sortable: true,
      renderCell: ({ row }) => <MetricCell value={row?.google_ads_sessions} />,
    },
    {
      key: 'meta_ads_sessions',
      name: <MetricHeader title='Meta ADS' icon='/icons/networks/meta.svg' />,
      sortable: true,
      renderCell: ({ row }) => <MetricCell value={row?.meta_ads_sessions} />,
    },
    {
      key: 'tiktok_ads_sessions',
      name: <MetricHeader title='TikTok ADS' icon='/icons/networks/tiktok.svg' />,
      sortable: true,
      renderCell: ({ row }) => <MetricCell value={row?.tiktok_ads_sessions} />,
    },
    {
      key: 'bing_ads_sessions',
      name: <MetricHeader title='Bing ADS' icon='/icons/networks/bing.svg' />,
      sortable: true,
      renderCell: ({ row }) => <MetricCell value={row?.bing_ads_sessions} />,
    },
    {
      key: 'date',
      name: 'Date',
      sortable: true,
      renderCell: ({ row }) => (
        <Flex align='center' gap={6}>
          <Icon
            size={0.6}
            path={mdiCalendar}
            color={Ninja.colors.textSecondary}
            style={{ opacity: 0.6 }}
          />
          <DateFormatter date={row.date} format='MMM DD, YYYY' className='font-normal' />
        </Flex>
      ),
    },
  ];

  return (
    <NinjaTable
      cardProps={{ disable: true }}
      title='Sources'
      dataProvider='getSources'
      columns={columns}
      queryParams={{
        filters: {
          ...filter,
        },
      }}
    />
  );
};

export default TrafficReportingSources;
